<template>
    <paper>
        <m-pane
            ref="tablePage"
            :virtual="true"
            :config="config"
            :totalData="totalData"
            :pageTotal="pageTotal"
            :searchTotalTitle="config.searchTotalTitle"
            :loading="loading"
            searchId="riskControlConfigQuery"
            pageID="riskControlConfig"
            :currentPage="query.pageNo"
            @edit-btn="handleEditBtn"
            @del-btn="handleDelBtn"
            @selectChange="selectChange"
            @searchChange="searchChange"
            @pageChange="pageChange"
            @sizeChange="sizeChange"
        >
            <div slot="table-module-btn">
                <el-tooltip
                    class="item"
                    effect="dark"
                    content="新增"
                    placement="bottom"
                >
                    <el-button
                        size="mini"
                        icon="el-icon-plus"
                        @click="handleAddData"
                        v-has="'riskControlConfig-add'"
                    ></el-button>
                </el-tooltip>
                <!-- <reportExport #default="{ submit }" reportCode="RISKCONTROL_CONFIG_EXPORT">
                    <el-tooltip effect="dark" content="导出" placement="bottom">
                        <span class="mgl-10">
                            <el-button icon="icon-daochu" size="mini" :disabled="pageTotal === 0" @click="exportFile(submit)"></el-button>
                        </span>
                    </el-tooltip>
                </reportExport> -->
            </div>

            <template #page-module-btn>
                <el-button
                    type="primary"
                    :disabled="!selected.length"
                    @click="handleBatchDelete"
                    v-has="'riskControlConfig-batchDel'"
                >批量删除</el-button>
            </template>
        </m-pane>

        <!-- 新增编辑弹窗 -->
        <performance-creation-dialog
            ref="performanceCreationDialog"
            :title="title"
            :rowData="rowData"
            :dialogVisible.sync="dialogVisible"
            v-if="dialogVisible"
            @handleClose="handleClose"
            @handleSuccess="handleSuccess"
        ></performance-creation-dialog>
    </paper>
</template>
<script>
import paper from '@/components/core/paper/Paper';
import mPane from '@/components/lots/VirtualPanel/index.vue';
import PerformanceCreationDialog from './component/addOrEditDialog/PerformanceCreationDialog.vue';
import config from './config.js';
import { mapState } from 'vuex';
import { messageTips, formatList } from './util.js';
import { batchDelete, queryRiskConfigPage, queryTotal } from '@otp/api/riskControlConfig.js';
// import reportExport from '@/components/lots/reportExportPlugin';
export default {
    name: 'riskControlConfig',
    components: {
        paper,
        mPane,
        // reportExport,
        PerformanceCreationDialog
    },
    data () {
        return {
            config,
            pageTotal: 0,
            loading: false,
            dialogVisible: false,
            totalData: [],
            selected: [],
            title: '',
            query: { pageNo: 1, pageSize: 10 },
            rowData: {}
        };
    },
    computed: {
        ...mapState({
            currentTenant: state => state.currentTenant
        })
    },
    methods: {
        getList () {
            this.loading = true;
            queryRiskConfigPage(this.query).then(res => {
                if (res && +res.code === 0) {
                    this.totalData = formatList(res.data.list || []);
                }
            }).finally(() => {
                this.loading = false;
            });
            this.getListPageCount();
        },
        getListPageCount () {
            queryTotal(this.query.param).then(res => {
                if (res && +res.code === 0) {
                    this.pageTotal = res.data || 0;
                }
            });
        },
        /**
         * @description 组装查询参数
         * @param {Object} data 查询参数
         */
        getSearchData (data) {
            const _searchData = {
                ...this.query,
                pageNo: 1,
                param: {
                    ...data
                }
            };
            return _searchData;
        },
        // 查询
        searchChange (data) {
            this.query = this.getSearchData(data);
            this.getList();
        },
        /**
         * @description 新增
         */
        handleAddData () {
            this.title = '新增配置';
            this.rowData = {};
            this.dialogVisible = true;
        },
        /**
         * @description 修改
         * @param {Object} rowData 当前行数据
         */
        handleEditBtn (rowData) {
            this.title = '编辑配置';
            this.rowData = rowData;
            this.dialogVisible = true;
        },
        handleClose () {
            this.dialogVisible = false;
        },
        handleSuccess () {
            this.handleClose();
            this.getList();
        },
        /**
         * @description 删除
         */
        handleDelBtn (data) {
            messageTips(`确定删除该配置?`, batchDelete, [data.id], '删除成功', this);
        },
        async handleBatchDelete() {
            const selectData = this.selected.map(item => item.id);
            messageTips(`是否批量删除配置?`, batchDelete, selectData, '删除成功', this);
        },
        async exportFile(submit) {
            submit({
                tenantCode: this.currentTenant.tenantCode,
                beginDate: '2000-11-11 00:00:00', // 后端固定要传参数
                endDate: '2030-11-11 00:00:00',
                ...this.query.param
            });
        },
        // 表格数据选中
        selectChange (data) {
            this.selected = data;
        },
        // 切换当前页数
        pageChange (pageNo) {
            this.query.pageNo = pageNo;
            this.getList();
        },
        // 切换当前分页显示条数
        sizeChange (pageSize) {
            this.query.pageNo = 1;
            this.query.pageSize = pageSize;
            this.getList();
        }
    }
};
</script>
